import { getSalesOrEvaluationsReports, salesOrEvaluationsAPIEndpointBuilder } from '@atlassian/mpac-api-client';
import { useTwoStepVerifiedAsync } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
export const useSalesOrEvaluationsReport = _ref => {
  let {
    mpacBaseUrl,
    partnerId,
    reportName,
    queryParams
  } = _ref;
  const apiPath = salesOrEvaluationsAPIEndpointBuilder(partnerId, reportName, queryParams);
  const promiseFn = useCallback(_ => getSalesOrEvaluationsReports(mpacBaseUrl, partnerId, reportName, queryParams), [partnerId, reportName, apiPath]);
  const {
    data,
    error,
    isPending
  } = useTwoStepVerifiedAsync({
    promiseFn
  });
  if (error) {
    log.error('useSalesReport', "Failed to retrieve Partner Sales Report", {
      error
    });
  }
  return {
    pending: isPending,
    error,
    salesOrEvaluations: data
  };
};